import { Action, AnyAction } from 'redux';
import { ErrorActionType } from '.';

interface NewErrorAction extends AnyAction {
    type: ErrorActionType.NewError;
    error: Error;
}

export interface ErrorClearedAction extends Action {
    type: ErrorActionType.ErrorCleared;
}

export const newError = (message: string, name: string): NewErrorAction => ({
    type: ErrorActionType.NewError,
    error: { message, name }
});

export const errorCleared: () => ErrorClearedAction = () => ({
    type: ErrorActionType.ErrorCleared,
});

export type ErrorAction =
    | NewErrorAction
    | ErrorClearedAction;



// WEBPACK FOOTER //
// ./src/actions/errorActions.ts